/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { challengeClipSourceSchema } from '../subtitle-extractions/clip-source-enums';
import { cropStatusSchema } from './enums/crop-status';
import { rejectionReasonSchema } from './enums/rejection-reason';

export const challengeClipSchema = z.object({
  id: z.number(),
  challengeId: z.number(),
  challengeTitle: z.string().nullable().optional(),
  sortOrder: z.number(),
  source: challengeClipSourceSchema.optional(),

  durationMs: z.number(),
  transcript: z.string().nullable(),

  subtitleId: z.number().nullable(),
  collectionId: z.number().nullable(),
  collectionPath: z.string().nullable().optional(),
  subtitleEntryIndices: z.string().nullable().optional(),
  startMs: z.number().nullable(),
  endMs: z.number().nullable(),
  padStartMs: z.number().nullable(),
  padEndMs: z.number().nullable(),
  baseLocalPath: z.string().nullable(),
  verticalLocalPath: z.string().nullable(),
  cropStatus: cropStatusSchema.nullable(),
  errorMessage: z.string().nullable(),
  vaultPath: z.string().nullable().optional(),

  fileSizeKb: z.number().nullable(),

  needsManualCrop: z.number().optional(),

  published: z.number(),
  basePath: z.string().nullable(),
  verticalPath: z.string().nullable(),
  verticalRejected: z.number().optional().default(0),

  triageAction: z.enum(['approved', 'rejected']).nullable(),
  rejectionReason: rejectionReasonSchema.nullable(),
  triagedAt: z.number().nullable(),

  createdAt: z.number(),
  updatedAt: z.number().nullable(),
});

export type IChallengeClip = z.infer<typeof challengeClipSchema>;
